import React from 'react'
import './shoppingCart.css'
import drill from '../../assets/drill.svg'
import rating from '../../assets/rating.svg'
import { getProductImageUrl } from 'Utils/getProductImageUrl'
import { Formatter } from 'Utils/Formatter'
import { t } from 'i18next'

export default function ShoppingCart({
  products,
  subtotal,
  itbms,
  total,
  priceChange,
}) {
  return (
    <div
      className="container-shopping-cart"
      id="container-shopping-cart"
      data-testid="container-shopping-cart">
      <>
        <h1 className="title-shopping-cart" data-testid="title-shopping-cart">
          {t('CUSTOMER_DISPLAY.TITLE_SHOPPING_CART')}
        </h1>
        <div
          className="container-elements-column"
          data-testid="container-cart-elements">
          <div
            className="container-products"
            data-testid="container-cart-products">
            {products?.length &&
              products
                ?.filter(
                  product =>
                    product.Category !== 'Instalación' &&
                    product.Category !== 'Otros servicios'
                )
                .map(product => (
                  <>
                    <div
                      className="card-product"
                      data-testid="card__product-cart">
                      <img
                        data-testid="img-product-cart"
                        src={getProductImageUrl(product)}
                        alt={product.ProductName}
                      />
                      <div
                        className="container-product-detail"
                        data-testid="container-product-detail-cart">
                        <p
                          className="text-product-name"
                          data-testid="text-product-name-cart">
                          {product.ProductName}
                        </p>
                        <div
                          className="container-product-codes"
                          data-testid="container-product-codes">
                          <p
                            className="text-codes"
                            data-testid="text-product-brand-cart">
                            {product.Brand}
                          </p>
                          <p
                            className="text-codes"
                            data-testid="text-product-sku-cart">
                            {product.Sku}
                          </p>
                          <p
                            className="text-codes"
                            data-testid="text-product-quantity-cart">{`x${product.Quantity} unidad`}</p>
                        </div>
                        <p
                          className="product-card-price"
                          data-testid="text-product-price-cart">
                          $
                          {Formatter.Money(
                            priceChange &&
                              priceChange.ProductId === product.ProductId
                              ? priceChange.Price
                              : product.Price
                          )}
                        </p>
                      </div>
                    </div>
                  </>
                ))}
          </div>
          <div
            className="detail-quote"
            data-testid="container-detail-quote-cart">
            <h3 className="title-totals" data-testid="title-totals-cart">
              {t('CUSTOMER_DISPLAY.TOTAL_SHOPPING_CART')}
            </h3>
            <hr />
            <div
              className="container-products-services-warranty"
              data-testid="container-services-warranty">
              {products?.length &&
                products
                  ?.filter(product => product.Category === 'Instalación')
                  .map(product => (
                    <>
                      <div
                        className="card-product-services-warranty"
                        data-testid="card__service-installation">
                        <img
                          src={drill}
                          alt={product.ProductName}
                          data-testid="img-service-installation"
                        />
                        <div className="container-product-detail">
                          <h4
                            className="font-weight"
                            data-testid="title-service-installation">
                            Servicio de instalación
                          </h4>
                          <p
                            className="text-product-name"
                            data-testid="text-service-name">
                            {product.ProductName}
                          </p>
                          <div className="container-product-codes">
                            <p
                              className="text-codes"
                              data-testid="text-service-sku">
                              {product.Sku}
                            </p>
                            <p
                              className="text-codes"
                              data-testid="text-service-quantity">{`x${product.Quantity} unidad`}</p>
                          </div>
                          <p
                            className="product-card-price-services-warranty"
                            data-testid="text-service-price">
                            ${Formatter.Money(product.FinalPrice)}
                          </p>
                        </div>
                      </div>
                      <hr />
                    </>
                  ))}
              {products?.length &&
                products
                  ?.filter(product => product.Category === 'Otros servicios')
                  .map(product => (
                    <>
                      <div
                        className="card-product-services-warranty"
                        data-testid="card__service-warranty">
                        <img
                          src={rating}
                          alt={product.ProductName}
                          data-testid="img-service-warranty"
                        />
                        <div className="container-product-detail">
                          <h4
                            className="font-weight"
                            data-testid="title-service-warranty">
                            {`Garantía extendida X ${product.WarrantyYears}`}{' '}
                            {product.WarrantyYears > 1 ? 'años' : 'año'}
                          </h4>
                          <p
                            className="text-product-name"
                            data-testid="text-warranty-name">
                            {product.ProductName}
                          </p>
                          <div className="container-product-codes">
                            <p
                              className="text-codes"
                              data-testid="text-warranty-sku">
                              {product.Sku}
                            </p>
                          </div>
                          <p
                            className="product-card-price-services-warranty"
                            data-testid="text-warranty-price">
                            ${Formatter.Money(product.FinalPrice)}
                          </p>
                        </div>
                      </div>
                      <hr />
                    </>
                  ))}
            </div>
            <div
              className="container-totals"
              data-testid="container-totals-cart">
              <div
                className="text-totals"
                data-testid="container-totals-labels">
                <p data-testid="label-subtotal-cart">Sub Total</p>
                <p data-testid="label-itbms-cart">ITBMS</p>
                <p className="font-weight" data-testid="label-total-cart">
                  Total
                </p>
              </div>
              <div
                className="number-totals"
                data-testid="container-totals-values">
                <p data-testid="text-subtotal-value-cart">{`$${Formatter.Money(
                  subtotal,
                  {
                    rounded: true,
                    decimalPrecision: 2,
                  }
                )}`}</p>
                <p data-testid="text-itbms-value-cart">{`$${Formatter.Money(
                  itbms,
                  {
                    rounded: true,
                    decimalPrecision: 2,
                  }
                )}`}</p>
                <p
                  className="font-weight"
                  data-testid="text-total-value-cart">{`$${Formatter.Money(
                  total,
                  {
                    rounded: true,
                    decimalPrecision: 2,
                  }
                )}`}</p>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}
